import { RenderingProps } from '@/shared/shared.types';
import { Field, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

export interface C46ChildrensAnimalMotifFields {
  FirstAnimalimage?: ImageField;
  FirstAnimalQuote?: Field<string>;
  SecondAnimalImage?: ImageField;
  SecondAnimalQuote?: Field<string>;
  ThirdAnimalImage?: ImageField;
  ThirdAnimalQuote?: Field<string>;
  FourthAnimalImage?: ImageField;
  FourthAnimalQuote?: Field<string>;
  FifthAnimalImage?: ImageField;
  FifthAnimalQuote?: Field<string>;
  StaticMobileImage?: ImageField;
}

export type C46ChildrensAnimalMotifRenderingParams = {
  randomAnimalIndex?: string;
};

export type C46ChildrensAnimalMotifProps = RenderingProps<
  C46ChildrensAnimalMotifFields,
  C46ChildrensAnimalMotifRenderingParams
>;
